import React from 'react';
import {
  createChatBotMessage,
  createCustomMessage,
  createClientMessage,
} from 'react-chatbot-kit';
import Header from '../components/chatbot/Header';
import BotAvatar from '../components/chatbot/BotAvater';
import ChatMessage from '../components/chatbot/ChatMessage';
import CustomMessage from '../components/chatbot/CustomMessage';
import CustomTextMessage from '../components/chatbot/CustomTextMessage';
import CustomSelectMessage from '../components/chatbot/CustomSelectMessage';
import ChatCustomIntro from '../components/chatbot/ChatCustomIntro';
import CustomImgMessage from '../components/chatbot/CustomImgMessage';

// import LinkMessage from '../components/chatbot/LinkMessage';
import WidgetFaq from '../components/chatbot/widget/WidgetFaq';
import WidgetCategory from '../components/chatbot/widget/WidgetCategory';
import WidgetCategoryList from '../components/chatbot/widget/WidgetCategoryList';
import WidgetLogin from '../components/chatbot/widget/WidgetLogin';
import WidgetWritetime from '../components/chatbot/widget/WidgetWritetime';
import WidgetSearchResult from '../components/chatbot/widget/WidgetSearchResult';
import WidgetSearchResultVer from '../components/chatbot/widget/WidgetSearchResultVer';
import WidgetPrev from '../components/chatbot/widget/WidgetPrev';
import WidgetYesNo from '../components/chatbot/widget/WidgetYesNo';
import WidgetEtc from '../components/chatbot/widget/WidgetEtc';
import WidgetQna from '../components/chatbot/widget/WidgetQna';
import WidgetChat from '../components/chatbot/widget/WidgetChat';
import WidgetSelectBox from '../components/chatbot/widget/WidgetSelectBox';
import WidgetGoodSearchResultVer from '../components/chatbot/widget/WidgetGoodSearchResultVer';
import WidgetIntro from '../components/chatbot/widget/WidgetIntro';
import Card from '../components/chatbot/Card';
import WidgetCollabo from '../components/chatbot/widget/WidgetCollabo';
import WidgetStore from '../components/chatbot/widget/WidgetStore';
import WidgetTimeline from '../components/chatbot/widget/WidgetTimeline';
import WidgetChannel from '../components/chatbot/widget/WidgetChannel';
import WidgetCompany from '../components/chatbot/widget/WidgetCompany';
import WidgetStock from '../components/chatbot/widget/WidgetStock';
import WidgetCart from '../components/chatbot/widget/WidgetCart';
import WidgetGoodOrderList from '../components/chatbot/widget/WidgetGoodOrderList';
import WidgetPointOrderList from '../components/chatbot/widget/WidgetPointOrderList.js';
import WidgetMemberShipOrderList from '../components/chatbot/widget/WidgetMemberShipOrderList.js';
import WidgetAgf from '../components/chatbot/widget/WidgetAgf.js';
import WidgetMemberShip from '../components/chatbot/widget/WidgetMemberShip.js';
import WidgetContentTimeline from '../components/chatbot/widget/WidgetContentTimeline.js';
import WidgetDeliverAddress from '../components/chatbot/widget/WidgetDeliverAddress.js';
import WidgetCustomer from '../components/chatbot/widget/WidgetCustomer.js';
import WidgetCustomer1 from '../components/chatbot/widget/WidgetCustomer1.js';
import moment from 'moment';
// import CustomInput from '../components/chatbot/CustomInput';
// import { shopContext } from '../contexts/aniplus';
// import { withRouter } from 'react-router-dom';

const botName = 'ANIPLUS CHATBOT';
const config = {
  botName: botName,
  initialMessages: [
    // createChatBotMessage(
    //   '안녕하세요! 애니플러스입니다.\n궁금한 내용을 간단히 입력해 주세요'
    // ),
    // createChatBotMessage(
    //   '예) 로그인 불가, 상품교환, 환불, 재생 불가, 다운로드 불가, 멤버십 가입, 포인트 구매'
    // ),
    // createChatBotMessage(
    //   '아래 내용이 궁금다면 클릭하여 빠르게 안내를 받아 보세요.',

    //   {
    //     widget: 'widget-faq',
    //   }
    // ),
    // createCustomMessage('', 'customTextMessage', {
    //   payload: {
    //     message: '',
    //   },
    // }),
    createCustomMessage('', 'customIntro'),
    // createCustomMessage(
    //   '안녕하세요! 애니플러스입니다.\n도움이 필요한 내용을 선택해 주세요!',
    //   'customTextMessage',
    //   {
    //     widget: '',
    //     payload: {
    //       message:
    //         '안녕하세요! 애니플러스입니다.\n도움이 필요한 내용을 선택해 주세요!',
    //       writetime: moment(new Date()).format('HH:mm'),
    //       widget: false,
    //     },
    //   }
    // ),
    // createCustomMessage('msg1', 'customSelectMessage', {
    //   widget: 'widget-category',
    //   payload: {
    //     message: 'msg1',
    //     writetime: moment(new Date()).format('HH:mm'),
    //     widget: true,
    //   },
    // }),
    // createCustomMessage(
    //   '예) 로그인 불가, 상품교환, 환불, 재생 불가, 다운로드 불가, 멤버십 가입, 포인트 구매',
    //   'customTextMessage',
    //   {
    //     payload: {
    //       message:
    //         '예) 로그인 불가, 상품교환, 환불, 재생 불가, 다운로드 불가, 멤버십 가입, 포인트 구매',
    //       writetime: moment(new Date()).format('HH:mm'),
    //     },
    //   }
    // ),
    // createCustomMessage(
    //   '아래 내용이 궁금다면 클릭하여 빠르게 안내를 받아 보세요.',
    //   'customTextMessage',
    //   {
    //     widget: 'widget-faq',
    //     payload: {
    //       message: '아래 내용이 궁금다면 클릭하여 빠르게 안내를 받아 보세요',
    //       writetime: moment(new Date()).format('HH:mm'),
    //       widget: true,
    //     },
    //   }
    // ),
    // createCustomMessage('test', 'customTextMessage', {
    //   payload: {
    //     message: (
    //       <Card
    //         title="괴수 8호"
    //         imageUrl="https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/content/CS_20240320110632.png"
    //         text="일상적으로 괴수가 사람들을 위협하는 세계. 괴수를 토벌하는 「방위대」 입대를 지망하던 히비노 카프카는, 언제부턴가 그 꿈을 포기하고 괴수 전문 청소업자로서 일하고 있었다. 「둘이서 괴수를 전멸시키자」 어린 시절 그렇게 함께 맹세한 소 "
    //         buttonText="바로가기"
    //         buttonUrl="https://www.aniplustv.com/items/3186"
    //       />
    //     ),
    //     writetime: moment(new Date()).format('HH:mm'),
    //     widget: false,
    //   },
    // }),
    // createClientMessage('클라이언트 메세지 테스트입니다.'),
    // createChatBotMessage('궁금한 내용을 입력해주세요.', {
    //   withAvatar: false,
    //   delay: 1500,
    //   //   widget: 'overview',
    // }),
    //createCustomMessage('this message test...', 'custom'),
  ],

  customMessages: {
    customIntro: (props) => <ChatCustomIntro {...props} />,
    customIntroTop: (props) => <WidgetIntro {...props} />,
    custom: (props) => <CustomMessage {...props} />,
    customTextMessage: (props) => <CustomTextMessage {...props} />,
    customLogin: (props) => <CustomMessage {...props} />,
    customSelectMessage: (props) => <CustomSelectMessage {...props} />,
    customImgMessage: (props) => <CustomImgMessage {...props} />,
  },
  customComponents: {
    // Replaces the default header
    header: () => <Header />,
    // Replaces the default bot avatar
    botAvatar: (props) => <BotAvatar {...props} />,
    // botAvatar: (props) => <div {...props} />,
    // Replaces the default bot chat message container
    // botChatMessage: (props) => <BotChatMessage {...props} />,
    botChatMessage: (props) => <ChatMessage {...props} bot={true} />,
    // Replaces the default user icon
    // userAvatar: (props) => <UserAvatar {...props} />,
    userAvatar: (props) => <div {...props} />,
    // Replaces the default user chat message
    // userChatMessage: (props) => <UserChatMessage {...props} />,
    userChatMessage: (props) => (
      <ChatMessage {...props} bot={false} userid="" />
    ),

    // userChatMessage: (props) => {
    //   //console.log(props);
    //   const botMessage = createCustomMessage(
    //     props.message,
    //     'customTextMessage',
    //     {
    //       payload: {
    //         message: props.message,
    //         writetime: moment(new Date()).format('HH:mm'),
    //       },
    //     }
    //   );
    //   return <ChatMessage {...botMessage} />;
    // },
  },

  // state: {
  //   gist: '',
  //   infoBox: '',
  // },
  widgets: [
    {
      widgetName: 'widget-faq',
      widgetFunc: (props) => <WidgetFaq {...props} />,
      // mapStateToProps: ['gist', 'infoBox'],
    },
    {
      widgetName: 'widget-category',
      widgetFunc: (props) => <WidgetCategory {...props} />,
      // mapStateToProps: ['gist', 'infoBox'],
    },
    {
      widgetName: 'widget-category-list',
      widgetFunc: (props) => <WidgetCategoryList {...props} />,
      // mapStateToProps: ['gist', 'infoBox'],
    },
    {
      widgetName: 'widget-login',
      widgetFunc: (props) => <WidgetLogin {...props} />,
    },
    {
      widgetName: 'widget-time',
      widgetFunc: (props) => <WidgetWritetime {...props} />,
    },
    {
      widgetName: 'widget-search-result',
      widgetFunc: (props) => <WidgetSearchResult {...props} />,
    },
    {
      widgetName: 'widget-search-result-ver',
      widgetFunc: (props) => <WidgetSearchResultVer {...props} />,
    },
    {
      widgetName: 'widget-content-suggestion',
      widgetFunc: (props) => <Card {...props} />,
    },
    {
      widgetName: 'widget-prev',
      widgetFunc: (props) => <WidgetPrev {...props} />,
    },
    {
      widgetName: 'widget-yesno',
      widgetFunc: (props) => <WidgetYesNo {...props} />,
    },
    {
      widgetName: 'widget-etc',
      widgetFunc: (props) => <WidgetEtc {...props} />,
    },
    {
      widgetName: 'widget-qna',
      widgetFunc: (props) => <WidgetQna {...props} />,
    },
    {
      widgetName: 'widget-chat',
      widgetFunc: (props) => <WidgetChat {...props} />,
    },
    {
      widgetName: 'widget-selectbox',
      widgetFunc: (props) => <WidgetSelectBox {...props} />,
    },
    {
      widgetName: 'widget-good-search-result-ver',
      widgetFunc: (props) => <WidgetGoodSearchResultVer {...props} />,
    },
    {
      widgetName: 'widget-collabo',
      widgetFunc: (props) => <WidgetCollabo {...props} />,
    },
    {
      widgetName: 'widget-store',
      widgetFunc: (props) => <WidgetStore {...props} />,
    },
    {
      widgetName: 'widget-timeline',
      widgetFunc: (props) => <WidgetTimeline {...props} />,
    },
    {
      widgetName: 'widget-channel',
      widgetFunc: (props) => <WidgetChannel {...props} />,
    },
    {
      widgetName: 'widget-company',
      widgetFunc: (props) => <WidgetCompany {...props} />,
    },
    {
      widgetName: 'widget-stock',
      widgetFunc: (props) => <WidgetStock {...props} />,
    },
    {
      widgetName: 'widget-cart',
      widgetFunc: (props) => <WidgetCart {...props} />,
    },
    {
      widgetName: 'widget-good-order-list',
      widgetFunc: (props) => <WidgetGoodOrderList {...props} />,
    },
    {
      widgetName: 'widget-point-order-list',
      widgetFunc: (props) => <WidgetPointOrderList {...props} />,
    },
    {
      widgetName: 'widget-membership-order-list',
      widgetFunc: (props) => <WidgetMemberShipOrderList {...props} />,
    },
    {
      widgetName: 'widget-agf',
      widgetFunc: (props) => <WidgetAgf {...props} />,
    },
    {
      widgetName: 'widget-membership',
      widgetFunc: (props) => <WidgetMemberShip {...props} />,
    },
    {
      widgetName: 'widget-content-timeline',
      widgetFunc: (props) => <WidgetContentTimeline {...props} />,
    },
    {
      widgetName: 'widget-delivery-address',
      widgetFunc: (props) => <WidgetDeliverAddress {...props} />,
    },
    {
      widgetName: 'widget-customer',
      widgetFunc: (props) => <WidgetCustomer {...props} />,
    },
    {
      widgetName: 'widget-customer1',
      widgetFunc: (props) => <WidgetCustomer1 {...props} />,
    },
  ],
  // customStyles: {
  //   botMessageBox: {
  //     backgroundColor: '#376B7E',
  //   },
  //   chatButton: {
  //     backgroundColor: '#5ccc9d',
  //   },
  // },
};

// export default shopContext(config);
export default config;
